import styled from 'styled-components';

export const TextboxContainer = styled.div`
  position: relative;

  .fixedControls {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    h2 {
      font-weight: 400;

      @media (max-width: 768px) {
        display: none;
      }
    }
  }
`;

export const TextboxViewport = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;
  height: 450px;
  overflow-y: overlay !important;
  border: 3px dotted rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 4px;

  &::-webkit-scrollbar {
    width: 20px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #d6dee1;
    border-radius: 20px;
    border: 6px solid transparent;
    background-clip: content-box;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #a8bbbf;
  }
`;
